<template>
  <div style="height:100%">
    <div class="check-header">
      <a-button
        type="primary"
        style="margin-right:12px"
        :disabled="!selectRow.materialId || !dataBottom.length"
        @click="showModal"
      >{{$t("page_material_check_input")}}</a-button>
      <a-upload
        style="display:inline-block;margin-right:12px"
        name="file"
        accept=".xlsx"
        :customRequest="importData"
        :fileList="[]"
      >
        <a-button>{{$t("page_business_data_import_product")}}</a-button>
      </a-upload>
      <a-button
        @click="exportData"
        style="margin-right:12px"
      >{{$t("page_business_data_export_product")}}</a-button>
      <a-button type="primary" @click="syncData">{{$t("page_material_check_sync")}}</a-button>
      <div style="float:right">
        <a-input-search
              v-acl="'page_product_search'"
              :placeholder="$t('common_please_input') + $t('keyword')"
              v-model="keyWords"
              allowClear
              @search="getTopData"
              :enterButton="$t('search')"
            />
      </div>
    </div>
    <div class="check-body">
      <div class="check-card">
        <ml-table
          :columns="columnTop"
          row-key="materialId"
          :data-source="dataTop"
          :pagination="false"
          :scroll="{ x: columnTop.length*120 }"
          :selectRowKey="selectRow.materialId"
          :customRow="(row) => ({
            on: {
              click: () => selectRow = row
            },
          })"
        ></ml-table>
        <a-pagination
        style="float:right;margin-bottom:5px;margin-top:5px;margin-right:20px;"
        :total="paginationTop.total"
        :showTotal="total => `${totalFanyi(total)}`"
        :pageSize="paginationTop.pageSize"
        :current="paginationTop.current"
        @change="pageIndexchange"
      ></a-pagination>
      </div>
      <div v-resize="'y'"></div>
      <div class="check-card">
        <ml-table
          :columns="columnBottom"
          :data-source="dataBottom"
          :pagination="false"
        >
          <template slot="time" slot-scope="text">
            <div>{{text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''}}</div>
          </template>
          <template slot="action" slot-scope="text, record, index">
            <div>
              <span v-if="record.editable">
                <a @click="() => onCheck(record, index)" style="margin-right:8px">{{$t("save")}}</a>
                <a
                  @click="record.editable = false; record.inventoryNum = dataCache[index].inventoryNum; bottomTableRemark = ''; isEdit = false"
                >{{$t("cancel")}}</a>
              </span>
              <span v-else>
                <a
                  v-if="!isEdit"
                  @click="bottomTableRemark = record.remark; record.editable = true; isEdit = true"
                >{{$t("edit")}}</a>
              </span>
            </div>
          </template>
          <template slot="inventoryNum" slot-scope="text, record">
            <a-input-number
              v-if="record.editable"
              :min="0"
              :max="999999999"
              v-model="record.inventoryNum"
            ></a-input-number>
            <template v-else>{{ record.inventoryNum }}</template>
          </template>
          <template slot="remark" slot-scope="text, record">
            <a-input v-if="record.editable" v-model="bottomTableRemark" :maxLength="255"></a-input>
            <ellipsis v-else tooltip :length="24">{{ record.remark}}</ellipsis>
          </template>
        </ml-table>
        <a-pagination
        style="float:right;margin-bottom:5px;margin-top:5px;margin-right:20px;"
        :total="paginationBottom.total"
        :showTotal="total => `${totalFanyi(total)}`"
        :pageSize="paginationBottom.pageSize"
        :current="paginationBottom.current"
        @change="pageIndexchange2"
      ></a-pagination>
      </div>
    </div>
    <a-modal v-model="visible" :title="$t('page_material_check')" @ok="checkAll" :width="800">
      <div>
        <div class="check-table-top">
          <div>{{$t("page_material_check_no")}}: {{selectRow.code}}</div>
          <div>{{$t("page_material_check_name")}}: {{selectRow.name}}</div>
          <div>{{$t("page_material_check_time")}}: {{dayjs().format('YYYY-MM-DD')}}</div>
          <div>{{$t("page_material_check_standardModel")}}: {{selectRow.standardModel}}</div>
          <div>{{$t("page_material_check_unit")}}: {{selectRow.unit}}</div>
          <div>{{$t("page_material_check_staff")}}: {{user}}</div>
        </div>
        <div class="check-table-bottom">
          <ml-table :columns="columnTable" :data-source="dataTable">
            <template slot="inventoryNum" slot-scope="_, record">
              <a-input-number :min="0" :max="999999999" v-model="record.inventoryNum"></a-input-number>
            </template>
          </ml-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { WarehouseMaterialInventoryServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MaterialFieldSettingServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
const whmisp = new WarehouseMaterialInventoryServiceProxy()
const mfssp = new MaterialFieldSettingServiceProxy()
import dayjs from 'dayjs'
import { exportCheck,importCheckDynamic } from '@/api/api'
import { downloadFile } from '@/utils/index'
import { isNull } from 'lodash'
import { getLocalStorage } from '@/utils/storage'

const toNumberOrNull = (x) => {
  const n = Number(x)
  return Number.isNaN(n) ? null : n
}

export default {
  data() {
    return {
      extendFieldList: [],
      dayjs,
      user: getLocalStorage('USER_INFO').nick_name,
      visible: false,
      selectRow: {},
      dataTop: [],
      dataBottom: [],
      dataCache: [],
      dataTable: [],
      columnTable: [
        {
          title: this.$t('page_material_check_area'),
          dataIndex: 'areaName',
        },
        {
          title: this.$t('page_material_check_location'),
          dataIndex: 'locationName',
        },
        {
          title: this.$t('page_material_check_locationnum'),
          dataIndex: 'locationNum',
        },
        {
          title: this.$t('page_material_check_inventorynum'),
          dataIndex: 'inventoryNum',
          scopedSlots: { customRender: 'inventoryNum' },
        },
      ],
      columnBottom: [
        {
          title: this.$t('actions'),
          scopedSlots: { customRender: 'action' },
          width: 110,
        },
        {
          title: this.$t('page_material_check_area'),
          dataIndex: 'areaName',
          width: 110,
        },
        {
          title: this.$t('page_material_check_location'),
          dataIndex: 'locationName',
          width: 110,
        },
        {
          title: this.$t('page_material_check_locationnum'),
          dataIndex: 'locationNum',
          width: 110,
        },
        {
          title: this.$t('page_material_check_inventorynum'),
          dataIndex: 'inventoryNum',
          scopedSlots: { customRender: 'inventoryNum' },
          width: 110,
        },
        {
          title: this.$t('page_material_check_errornum'),
          dataIndex: 'errorNum',
          width: 110,
        },
        {
          title: this.$t('page_material_check_time'),
          dataIndex: 'inventoryTime',
          scopedSlots: { customRender: 'time' },
          width: 150,
        },
        {
          title: this.$t('page_material_check_staff'),
          dataIndex: 'inventoryUserName',
          width: 110,
        },
        {
          title: this.$t('remark'),
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
        },
      ],
      paginationTop: {
        current: 1,
        total:0,
        pageSize: 10,
      },
      paginationBottom: {
        current: 1,
        total:0,
        pageSize: 1,
      },
      bottomTableRemark: '',
      isEdit: false,
      keyWords: "",
    }
  },
  computed: {
    columnTop() {
      let extendCols = []
      this.extendFieldList.map(item => {
        if (item.isDisplay === 1) {
          extendCols.push({
            title: item.name,
            dataIndex: item.code,
            width: 100,
            ellipsis: true
          })
        }
      })
      return [
        {
          title: this.$t('page_material_check_barCode'),
          dataIndex: 'barCode',
          width: 110,
        },
        {
          title: this.$t('page_material_check_no'),
          dataIndex: 'code',
          width: 110,
        },
        {
          title: this.$t('page_material_check_name'),
          dataIndex: 'name',
          width: 110,
        },
        {
          title: this.$t('page_business_material_1'),
          dataIndex: 'materialStuff',
          width: 110,
        },
        {
          title: this.$t('page_material_check_standardModel'),
          dataIndex: 'standardModel',
          width: 110,
        },
        {
          title: this.$t('page_material_check_unit'),
          dataIndex: 'unit',
          width: 110,
        },
        {
          title: this.$t('page_material_check_locationnum'),
          dataIndex: 'locationNum',
          width: 110,
        },
        {
          title: this.$t('page_material_check_inventorynum'),
          dataIndex: 'inventoryNum',
          width: 110,
        },
        {
          title: this.$t('page_material_check_errornum'),
          dataIndex: 'errorNum',
          width: 110,
        },
        {
          title: this.$t('remark'),
          dataIndex: 'remark',
          width: 110,
        },
        ...extendCols
      ]
    }
  },
  watch: {
    'selectRow.materialId': {
      handler(val, oldval) {
        if (val === oldval) return
        this.isEdit = false
        this.getBottomData()
      },
    },
  },
  mounted() {
    this.getTopData()
    this.getFieldSetting()
  },
  methods: {
    async getFieldSetting() {
      this.extendFieldList = await mfssp.get()
    },
    pageIndexchange(currentPage) {
      this.paginationTop.current = currentPage;
      this.getTopData();
    },
    pageIndexchange2(currentPage) {
      this.paginationBottom.current = currentPage;
      this.getBottomData();
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    exportData() {
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      exportCheck(areaId,this.keyWords).then((res) => {
        downloadFile(res, 'check.xlsx')
      })
    },
    importData(e) {
      const file = e.file
      const data = new FormData()
      data.append('file',file)
      const that = this
      importCheckDynamic(data).then(res =>{
        let reader = new FileReader()
        reader.readAsText(res)
        reader.onload = e => {
          if(reader.result == "") {
            that.$message.success(that.$t('page_material_check_success_tip'))
            that.getTopData()
            that.getBottomData()
          } else {
            downloadFile(res, 'check.xlsx')
          }
        }
      })
    },
    async check(record, index) {
      if (record.inventoryTime) {
        record.inventoryTime = undefined
      }
      await whmisp.inventory({
        warehouseMaterialInventoryList: [record].map((item) => ({
          ...item,
          inventoryTime: dayjs(item.inventoryTime).format('YYYY-MM-DD HH:mm:ss'),
        })),
      })
      this.$message.success(this.$t('page_material_check_success'))
      record.editable = false
      this.dataCache[index].inventoryNum = record.inventoryNum
      this.getTopData()
      this.getBottomData()
      this.isEdit = false
    },
    async checkAll() {
      // if (isNull(this.dataTable[0].inventoryNum)) {
      //   this.$message.error('实盘数量未填写')
      //   return
      // }
      const bool = this.dataTable.some((item) => {
        return isNull(item.inventoryNum)
      })

      if (bool) {
        this.$message.error(this.$t('page_material_check_error_tip'))
        return
      }
      await whmisp.inventory({
        warehouseMaterialInventoryList: this.dataTable.map((item) => ({
          ...item,
          inventoryTime: dayjs(item.inventoryTime).format('YYYY-MM-DD HH:mm:ss'),
        })),
      })
      this.$message.success(this.$t('page_material_check_success'))
      this.visible = false
      this.getTopData()
      this.getBottomData()
    },
    async showModal() {
      this.visible = true
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      const materialId = this.selectRow.materialId
      const { records = [] } = await whmisp.pageWarehouseMaterialInventory(areaId, 1, materialId, -1)
      this.dataTable = records.map((item) => ({
        ...item,
        inventoryNum: toNumberOrNull(item.inventoryNum),
        errorNum: toNumberOrNull(item.errorNum),
      }))
    },
    handleChange(type) {
      return (pagination, ...rest) => {
        const pager = { ...this[`pagination${type}`] }
        pager.current = pagination.current
        this[`pagination${type}`] = pager
        this[`get${type}Data`]()
      }
    },
    async getTopData() {
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      const keyWord = ''
      const { records = [], total } = await whmisp.pageWarehouseMaterialInventoryForArea(
        areaId,
        this.paginationTop.current,
        this.keyWords,
        this.paginationTop.pageSize
      )
      this.dataTop = records.map((item) => ({
        ...item,
        inventoryNum: toNumberOrNull(item.inventoryNum),
        errorNum: toNumberOrNull(item.errorNum),
      }))
      const pagination = { ...this.paginationTop }
      pagination.total = total
      this.paginationTop = pagination
    },
    async getBottomData() {
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      const materialId = this.selectRow.materialId
      const { records = [], total } = await whmisp.pageWarehouseMaterialInventory(
        areaId,
        this.paginationBottom.current,
        materialId,
        this.paginationBottom.pageSize
      )
      const cache = []
      records.forEach((item) => {
        item.editable = false
        item.inventoryNum = toNumberOrNull(item.inventoryNum)
        item.errorNum = toNumberOrNull(item.errorNum)
        cache.push({
          ...item,
        })
      })
      this.dataBottom = records
      this.dataCache = cache
      const pagination = { ...this.paginationBottom }
      pagination.total = total
      this.paginationBottom = pagination
    },
    async syncData() {
      const wmsRouters = this.$store.getters.wmsRoutes
      const areaId = (this.$route.query.materialId
        ? this.$route.query.materialId
        : wmsRouters && wmsRouters[0] && wmsRouters[0].id
      ).toString()
      await whmisp.sync(areaId)
      this.getTopData()
      this.getBottomData()
      this.$message.success(this.$t('page_material_check_sync_success'))
    },

    onCheck(record, index) {
      if (isNull(record.inventoryNum)) {
        this.$message.error(this.$t('page_wuliao_un_input'))
        return
      }
      record.remark = this.bottomTableRemark
      this.check(record, index)
    },
    covertTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
  },
}
</script>

<style lang="less" scoped>
.check-header {
  height: 40px;
}

.check-body {
  height: calc(100% - 40px);
}

.check-card {
  width: 100%;
  height: 50%;
  background: white;
  overflow-y: auto;
}

.check-table-top {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  > div {
    height: 42px;
    line-height: 42px;
    width: calc(100% / 3);
  }
}

.check-table-bottom {
  max-height: 500px;
  overflow-y: auto;
}
</style>
